import { getCrmBaseUrl, getCrmLogoutUrl } from '@/utils/crm/crmUrls';

export const SEARCH_PATH = '/search/';
export const SEARCH_DETAILS_PATH = '/search-details/';
export const USER_MANAGEMENT_PATH = '/user-management/';
export const DASHBOARD_PATH = '/dashboard/';
export const CALENDAR_PATH = '/calendar/';
export const INTERNAL_CLIENTS_PATH = '/clients/';
export const CLIENT_DETAIL_PATH = getPath('/client-detail/');
export const CLIENT_DETAIL_INTERNAL_PATH = '/client-detail';
export const CLIENT_CARD_VAULT_PATH = '/client-detail/cards/';
export const CLIENT_CREATE_PATH = '/clients/create/';
export const CLIENTS_CREATE_PATH = '/clients/create';
export const AIR_REQUEST_PATH = '/air-request/';
export const PARTNERS_PATH = getPath('/partners/');
export const FORUM_PATH = getPath('/forum/');
export const DIRECTORIES_PATH = getPath('/agents/');
export const TOOLKIT_SHOW_PATH = getPath('/toolkit/show/');
export const TOOLKIT_DETAIL_PATH = getPath('/toolkit-detail/');
export const TRAINING_PATH = getPath('/trainings/');
export const FAQ_PATH = getPath('/faqs/');
export const SETTINGS_PATH = getPath('/settings/');
export const MARKETING_PATH = getPath('/user-settings-request/');
export const WEBSITE_MANAGEMENT_PATH = '/marketing/website/';

/** Full CRM logout URL (e.g. https://society.smartflyer.com/logout). Override with NEXT_PUBLIC_CRM_LOGOUT_URL. */
export const LOGOUT_PATH = getCrmLogoutUrl();

/** In-app URL: clears `localStorage` token then sends user to CRM logout (`LOGOUT_PATH`). Optional `?redirect=` (absolute URL, SmartFlyer hosts only). */
export const APP_CRM_LOGOUT_PATH = '/crm-logout/';
export const LOGIN_REDIRECT_PATH = '/login-redirect/';
export const CLIENT_PROFILE_FORM_PATH = '/update/data/profile/';
export const CLIENT_CREDIT_CARD_FORM_PATH = '/update/data/credit-card/';
export const MAINTENANCE_PATH = getPath('/maintenance');

// CONTENT > Society crm
export const FORUM_CHANNELS_PATH = getPath('/forum-channels/');
export const FORUM_CATEGORIES_PATH = getPath('/forum-category/');
export const TOOLKIT_PATH = getPath('/toolkit/');
export const AGENT_LOCATIONS_PATH = getPath('/agent-locations/');
export const AGENCY_LIST_PATH = getPath('/agency_list/');
export const AWARDS_PATH = getPath('/awards/');
export const NEWSLETTERS_PATH = getPath('/newsletters/');
export const CATEGORIES_PATH = getPath('/categories/');
export const GALLERY_PATH = '/gallery/';
export const LOYALTY_CATEGORIES_PATH = getPath('/loyalty_categories/');
export const AGENT_EXPERTISE_PATH = getPath('/expertise/');

// CONTENT > smartflyer
export const HOME_PAGE_CONTENT_PATH = getPath('/home_page_content/');
export const DESTINATION_LIST_PATH = getPath('/destination_list/');
export const CAREER_AT_SMARTFLYER_FORM_PATH = getPath('/career_at_smartflyer_form/');
export const ABOUT_FORM_PATH = getPath('/about_form/');
export const SMARTFLYER_AU_PATH = getPath('/smartflyer_au/');
export const WHAT_WE_DO_FORM_PATH = getPath('/what_we_do_form/');
export const STORY_LIST_PATH = getPath('/story_list/');
export const STORIES_PATH = '/stories/';
export const PRESS_ROOM_PATH = getPath('/press_room/');
export const NEWS_LIST_PATH = getPath('/news_list/');
export const TEAM_PATH = getPath('/team/');
export const AGENT_FRONTEND_SETTINGS_PATH = getPath('/agent_frontend_settings/');

export function getPath(path: string) {
  return `${getCrmBaseUrl()}${path}`;
}
